module.exports = __webpack_public_path__ + "media/images/icons/smartfone-4fee19d26be782d95053bf0016854d6b.png";